import PropTypes from 'prop-types';
import OutlineInvoice from 'Components/Atoms/OutlineIcons/OutlineInvoice';
import { INVOICE_TYPES } from 'Utils/constants';
import { cn } from 'Utils/cn';

// Same 32px icon box as the Tagging queue items: the bank logo for transactions, a colored invoice icon for invoices.
export default function ReconciliationItemIcon({ logoUrl, invoice }) {
    if (invoice) {
        const isIncome = invoice.type === INVOICE_TYPES.SALE;

        return (
            <div
                className={cn(
                    'size-8 rounded-md grid place-content-center',
                    isIncome ? 'bg-income/10 text-income' : 'bg-danger/10 text-danger',
                )}
            >
                <OutlineInvoice size={18} color="currentColor" />
            </div>
        );
    }

    return (
        <div className="size-8 rounded-md bg-gray-100 grid place-content-center overflow-hidden">
            {logoUrl && <img src={logoUrl} width={22} height={22} alt="" />}
        </div>
    );
}

ReconciliationItemIcon.propTypes = {
    logoUrl: PropTypes.string,
    invoice: PropTypes.shape({
        type: PropTypes.string,
    }),
};
